module.exports = __webpack_public_path__ + "media/images/itch-f447926dd4f618e6f49fbe557287da13.png";